// Date/time formatting for the printed supplier documents (#809): the operator's
// locale, medium date + short time. The CSV twins carry ISO instants untouched.

export function fmtDateTime(iso: string | null | undefined, lang: string): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleString(lang, { dateStyle: 'medium', timeStyle: 'short' });
}

export function fmtDate(iso: string | null | undefined, lang: string): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleDateString(lang, { dateStyle: 'medium' });
}

export function fmtTime(iso: string | null | undefined, lang: string): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleTimeString(lang, { timeStyle: 'short' });
}
